import { useEffect, useState } from 'react';
import { api } from './api.ts';

export type OptionMap = Record<string, string[]>;

/**
 * The option lists change rarely, so fetch them once per page load and share
 * the promise. Every form field would otherwise refetch the same payload.
 */
let cached: Promise<OptionMap> | null = null;

export function loadOptions(): Promise<OptionMap> {
  cached ??= api
    .get<{ options: OptionMap }>('/api/options')
    .then((r) => r.options)
    .catch(() => ({}));
  return cached;
}

/** Drop the cache after Settings changes something, so forms pick it up. */
export function invalidateOptions(): void {
  cached = null;
}

export function useOptions(): OptionMap {
  const [options, setOptions] = useState<OptionMap>({});
  useEffect(() => {
    let alive = true;
    void loadOptions().then((o) => { if (alive) setOptions(o); });
    return () => { alive = false; };
  }, []);
  return options;
}
